var React = require('react');

function UiMinus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Minus"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M29.7,2.5c0,1.4-1.1,2.5-2.5,2.5c0,0,0,0,0,0H2.5C1.1,5.1,0,4,0,2.5S1.1,0,2.5,0h24.6\n\t\t\tC28.5,0,29.7,1.1,29.7,2.5C29.7,2.5,29.7,2.5,29.7,2.5z"})))]);
}

UiMinus.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 29.7 5.1","style":{"enableBackground":"new 0 0 29.7 5.1"},"xmlSpace":"preserve"};

module.exports = UiMinus;

UiMinus.default = UiMinus;
